import { render, staticRenderFns } from "./AddTeamEntriesStandingTournament.vue?vue&type=template&id=8a52b270&scoped=true"
import script from "./AddTeamEntriesStandingTournament.vue?vue&type=script&lang=js"
export * from "./AddTeamEntriesStandingTournament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a52b270",
  null
  
)

export default component.exports